@if (customEditedRouteResponse() && isEditRouteRegisterOpen()) {
  <section class="edit-route-register__section">
    @if (checkIsSuccessList()) {
      <article class="edit-route-register__article">
        <header class="edit-route-register__header">
          <h2 class="edit-route-register__title ci-heading-h2-s-bold">
            {{ 'Modificados' }}
          </h2>
        </header>
        
        <main class="edit-route-register__main">
          <ci-scroll-fade [height]="getHeightScrollFade()">
            <ul class="edit-route-register__item-list">
              @for(successItem of customEditedRouteResponse().success; track successItem.id) {
                <li class="edit-route-register__item">
                  <ci-icon 
                    class="edit-route-register__success-icon"
                    name="success" 
                    scale="1x"
                  ></ci-icon>

                  <span class="edit-route-register__text ci-paragraph-p1-semibold">
                    {{ successItem.title }}
                  </span>
                </li>
              }
            </ul>
          </ci-scroll-fade>
        </main>
      </article>
    }
    
    @if (checkIsErrorList()) {
      <article class="edit-route-register__article">
        <header class="edit-route-register__header">
          <h2 class="edit-route-register__title ci-heading-h2-s-bold">
            {{ 'No modificados' }}
          </h2>
        </header>
        
        <main class="edit-route-register__main">
          <ci-scroll-fade [height]="getHeightScrollFade()">
            <ul class="edit-route-register__item-list">
              @for(errorItem of customEditedRouteResponse().error; track errorItem.id) {
                <li class="edit-route-register__item">
                  <ci-icon 
                    class="edit-route-register__error-icon"
                    name="error" 
                    scale="1x"
                  ></ci-icon>

                  <div class="edit-route-register__text-wrapper">
                    <span class="edit-route-register__text ci-paragraph-p1-semibold">
                      {{ errorItem.title }}
                    </span>
                    <span class="edit-route-register__text ci-paragraph-p1-regular">
                      {{ errorItem.motive }}
                    </span>
                  </div>
                </li>
              }
            </ul>
          </ci-scroll-fade>
        </main>
      </article>
    }
    
    <ci-button 
      class="edit-route-register__button"
      class-name="ci-btn-primary-m-filled" 
      type="button" 
      [aria-label]="'Volver a la ruta' | translate"
      (click)="handleBackToEditRouteClick()"
    >
      {{ 'Volver a la ruta' | translate}}
    </ci-button>
  </section>
}